<template>
    <h5>
        <span style="display: flex;">
            <span class="hPoints bg-alerta" style="cursor: pointer"
                :style="{ opacity: (item.filtrar && !item.filtrar.includes('Pendente')) ? '0.3' : '1' }"
                @click="handleFilter('Pendente')">{{ hp[0] }}</span>
            <span class="hPoints bg-ok" style="cursor: pointer"
                :style="{ opacity: (item.filtrar && !item.filtrar.some(status => andamentoStatuses.includes(status))) ? '0.3' : '1' }"
                @click="handleFilter(andamentoStatuses)">{{ hp[1] }}</span>
            <span class="hPoints bg-sucesso" style="cursor: pointer"
                :style="{ opacity: (item.filtrar && !item.filtrar.includes('Concluído')) ? '0.3' : '1' }"
                @click="handleFilter('Concluído')">{{ hp[2] }}</span>
        </span>
    </h5>
</template>
<script>
export default {
    name: 'HPStatus',
    props: {
        item: { type: Object, required: true },
        somarHP: { type: Function, required: true }
    },
    methods: {
        handleFilter(statuses) {
            if (!Array.isArray(statuses)) statuses = [statuses];
            const current = this.item.filtrar || [];
            if (
                current.length === statuses.length &&
                statuses.every(s => current.includes(s))
            ) {
                this.$emit('filtrar', null);
            } else {
                this.$emit('filtrar', statuses);
            }
        }
    },
    computed: {
        hp() {
            return this.somarHP(this.item);
        },
        andamentoStatuses() {
            return ['Em andamento', 'Em andamento 25%', 'Em andamento 50%', 'Em andamento 75%'];
        }
    },
}
</script>